import { Expose } from "class-transformer";

export default class NotificationReadRes {
  @Expose() readonly notificationReadId!: number;
  @Expose() readonly companyId!: number;
  @Expose() readonly notificationId!: number;
  @Expose() readonly castId?: number;
  @Expose() readonly driverId?: number;
}
